import { isLoadingHandler } from '../Utils'

export const SET_COMPATIBILITY_MAPPING = 'SET_COMPATIBILITY_MAPPING'
export const IS_LOADING = 'COMPATIBILITY_IS_LOADING'

const INITIAL_STATE = {
    isLoading: false,
    apis: {},
    commonApis: {},
    consoleSpecificApis: {},
};

const ACTION_HANDLERS = {
    [IS_LOADING]: isLoadingHandler,
    [SET_COMPATIBILITY_MAPPING]: (state, { payload }) => ({
        ...state,
        apis: payload.compatibilityMapping.apis,
        commonApis: payload.compatibilityMapping.commonApis,
        consoleSpecificApis: payload.compatibilityMapping.consoleSpecificApis,
    }),
};

export default (state = INITIAL_STATE, action) => {
    const handler = ACTION_HANDLERS[action.type]
    return handler ? handler(state, action) : state
};



// WEBPACK FOOTER //
// ./src/store/reducers/compatibility.js